export const config = {
    managerName: "Mona Manzano",
    phoneNumber: "618-910-3215",
    emailServerToEmail:  "mona.manzano.kchall@gmail.com",
    emailServerUrl: "https://glacial-wave-54745.herokuapp.com/contact/kchall",
    facebookLink: "https://www.facebook.com/KnightsOfColumbus4239",
    facebookAppId: 538708347039764,
    facebookPageId: 460408880684029,
}